<!--
  Script criado a partir de uma lib.
  Disponível em https://pdfanticopy.com/no-print-js.html#google_vignette para posteriores atualizações.
-->

<script setup>
import { onMounted, onUnmounted } from 'vue';

const noCopy = true;
const noPrint = true;
const noScreenshot = true;
// const autoBlur = true;

function toBlur() {
  // if (autoBlur) {
  //   document.body.style.cssText = 'filter: blur(5px); -webkit-filter: blur(5px);';
  // }
}

function toClear() {
  // document.body.style.cssText = 'filter: blur(0px); -webkit-filter: blur(0px);';
}

function preventShortcuts(e) {
  if ((e.ctrlKey || e.metaKey) && (e.key === 's' || e.keyCode === 83)) {
    e.preventDefault();
  }
  if ((e.ctrlKey || e.metaKey) && e.key === 'p' && noPrint) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
}

// function preventPrintScreen(e) {
//   var keyCode = e.keyCode ? e.keyCode : e.which;
//   if ((keyCode === 44 || e.key === 'PrintScreen') && noScreenshot) {
//     navigator.clipboard.writeText('');
//     let questions = document.getElementById('questions-block');
//     questions.style.display = "none";
//     setTimeout(() => {
//       alert('Você não pode executar essa ação, por favor retorne a prova!');
//       questions.style.display = "block"
//     }, 1200);
//     // const myButton = document.createElement('button');
//     // myButton.id = 'no-print-button';
//     // myButton.textContent = 'Clique aqui para voltar o conteúdo da página';
//     // myButton.addEventListener('click', handleClick);
//   }
// }

function preventPrintScreenOnBlur() {
  if (noScreenshot) {
    let questions = document.getElementById('questions-block');
    questions.style.display = "none";
    setTimeout(() => {
      alert('Esta ação não pode ser executada. Por gentileza, retorne a prova.');
      questions.style.display = "block"
    }, 600);
  }
}

 // function handleClick() {
 //        let questions = document.getElementById('questions-block');
 //        let noPrintButton = document.getElementById('no-print-button');
 //        questions.style.display = "block";
 //        noPrintButton.style.display = "none";
 //    }

function disableCopyContextSelect() {
  document.body.oncopy = () => false;
  document.body.oncontextmenu = () => false;
  document.body.ondrag = () => false;
}

function createPrintBlocker() {
  // const c = document.createElement('span');
  // c.style.display = 'none';
  // c.style.position = 'absolute';
  // c.style.background = '#000';
  // c.setAttribute('width', document.body.scrollWidth);
  // c.setAttribute('height', document.body.scrollHeight);
  // document.body.insertBefore(c, document.body.firstChild);
  // c.style.display = 'block';

  // const css = document.createElement('style');
  // css.type = 'text/css';
  // css.media = 'print';
  // css.innerHTML = 'body { display: none; }';
  // document.head.appendChild(css);
}

function addUserSelectCSS() {
  const css = document.createElement('style');
  css.type = 'text/css';
  css.media = 'screen';
  css.innerHTML = `
    div {
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  `;
  document.head.appendChild(css);

  document.body.style.cssText = `
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  `;
}

onMounted(() => {
  if (noCopy) disableCopyContextSelect();
  if (noPrint) createPrintBlocker();
  addUserSelectCSS();

  document.onclick = toClear;
  document.onmouseleave = toBlur;
  document.onblur = toBlur;

  document.addEventListener('keydown', preventShortcuts);
  // document.addEventListener('keyup', preventPrintScreen);
  window.addEventListener("blur", preventPrintScreenOnBlur)
});

onUnmounted(() => {
  // Limpeza
  document.onclick = null;
  document.onmouseleave = null;
  document.onblur = null;

  document.removeEventListener('keydown', preventShortcuts);
  // document.removeEventListener('keyup', preventPrintScreen);
});
</script>
